module.exports = __webpack_public_path__ + "media/images/WishCollage-576d481e.jpg";